module["exports"] = [
  "#{Name.last_name}#{street_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/street_name.js
// module id = 2007
// module chunks = 0